import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { OpSenseToastContainer, toast } from '../Toast';
import { PageTitle } from '../PageTitle';
import AssetForm from './asset_form';
import { AssetsService } from '../../services';

@connect(state => {
  return {
    me: state.user.me
  }
})
class AssetAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      added: null,
      enterprise: this.props.me.enterprise,
      floorplanLocation: null,
      assetImages: [],
      saving: false
    };
  }

  handleSubmit(assetFormData) {
    this.setState({saving: true});
    
    let tags = assetFormData.genericTags.map((tag) => ({id: tag.value}));
    if (assetFormData.areaTag) {
      tags.push({id: assetFormData.areaTag.value});
    }
    
    const metadata = assetFormData.assetType.assetType.assetTypeMetadataTypes.map((metadataType) => {
      if (metadataType.stringValueFlag) {
        return ({ assetTypeMetadataType: {id: metadataType.id}, stringValue: assetFormData[`metadata-${metadataType.id}`] });
      } else {
        return ({ assetTypeMetadataType: {id: metadataType.id}, numericValue: assetFormData[`metadata-${metadataType.id}`] });
      }
    });

    const measures = assetFormData.measures.filter((measure) => (measure.device != null))
                                           .map((measure) => ({
                                              device: {id: measure.device.id}, 
                                              deviceDataType: {
                                                id: measure.deviceDataType.id,
                                              },
                                              assetTypeDeviceDataType: {
                                                id: measure.assetTypeDeviceDataType.id,
                                                deviceDataClassification: { id: measure.assetTypeDeviceDataType.deviceDataClassification.id }
                                              },
                                              startAt: measure.startAt
                                            }));

    let asset = {
      enterprise: {id: this.state.enterprise.id},
      name: assetFormData.name,
      archived: false,
      assetType: { id: assetFormData.assetType.assetType.id },
      businessGroup: { id: assetFormData.businessGroup.value },
      tags: tags,
      assetMeasures: measures,
      assetMetadata: metadata,
      floorPlanX: this.state.floorplanLocation != null ? this.state.floorplanLocation.x : -1,
      floorPlanY: this.state.floorplanLocation != null ? this.state.floorplanLocation.y : -1
    };

    AssetsService.add(asset).then(response => {      
      Promise.all(this.state.assetImages.map((assetImage) => AssetsService.uploadImage(response.asset.id, assetImage.file))).then((results) => {
        this.setState({ added: response.asset });
        this.setState({saving: false});  
      }).catch(error => {
        console.error(error);
        this.setState({saving: false});  
        toast.error(i18next.t('messages.asset-image-upload-failure'));
      });
    }).catch(error => {
      console.error(error);      
      this.setState({saving: false});  
      toast.error(error.message);
    });    
  }
  
  render() {
    if (this.state.added) {
      return (
          <Redirect to={{
            pathname: '/config/assets',
            state: {
              from: this.props.location,
              successMessage: i18next.t('messages.asset-added')
            }
          }}/>
      );
    } else {
      if (this.state.enterprise && !this.state.saving) {
        const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
        return (
          <div className="assets">
            <OpSenseToastContainer />

            <div className="row">
              <PageTitle title={i18next.t('pages.assets.add-asset')}
                          backLinkWithParams={{
                            link: {
                              pathname: "/config/assets",
                              search: backLinkSearch
                            }
                          }} />
            </div>

            <AssetForm
                onSubmit={this.handleSubmit.bind(this)}
                onFloorplanLocationChange={(location) => {this.setState({floorplanLocation: location})}}
                onAssetImageChange={(assetImages) => {this.setState({assetImages: assetImages})}}
                backLinkWithParams={{
                  link: {
                    pathname: "/config/assets",
                    search: backLinkSearch
                  }
                }}
            />
          </div>
        );
      } else {
        return (
          <div>
            <OpSenseToastContainer />

            <div className="loader">{i18next.t('loading')}</div>
          </div>
        );
      }
    }
  }
}

export default AssetAdd;
